// The hosts real users reach MyFVSD on. Everything else — localhost, LAN IPs,
// mydev.fvsd.ab.ca and the *.ondigitalocean.app preview URLs — is development
// or staging traffic that would skew the production project's numbers (#585).
export const POSTHOG_PRODUCTION_HOSTS = ['my.fvsd.ab.ca', 'myfvsd.ca'];

// `override` is REACT_APP_POSTHOG_ENABLED: 'true' forces PostHog on for any
// host (to test tracking locally), 'false' forces it off. Unset, the host decides.
export function shouldEnablePostHog({ key, hostname, override }) {
  if (!key) return false;
  if (override === 'true') return true;
  if (override === 'false') return false;
  return POSTHOG_PRODUCTION_HOSTS.includes(hostname);
}
